import { IsInt, IsNotEmpty } from 'class-validator';

export class PersonGetDealerGaugersRequest {
    @IsInt()
    @IsNotEmpty()
    public dealerId: number;

    constructor(data?: Partial<PersonGetDealerGaugersRequest>) {
        this.dealerId = data?.dealerId;
    }
}
